<label class="emd-switcher__label" [for]="switcherId">
    <input
        type="checkbox"
        [checked]="checked"
        [disabled]="disabled || (isLoading$ | async)"
        (click)="$event.preventDefault(); checkedChange.next(getEventValue($event))"
        class="emd-switcher _color_primary"
        [id]="switcherId"
    />
    <div class="emd-switcher__area"></div>
    <div
        class="spinner-border text-black spinner-text-size ml-2"
        role="status"
        *ngIf="(isLoading$ | async) && allowLoadingSpinner"
    ></div>
</label>
